export const prevArrow = `
    <button class="slider__arrow slider__prev slick-prev link" aria-label="Previous slide">
        <svg class="icon icon--arrow arrow--left" xmlns="http://www.w3.org/2000/svg" viewBox="0 7.709 48 26.739" width="48" height="26.739" style="transform: rotate(180deg)">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4.288586106767925" d="M2.145 21.879h37.669" />
            <path d="M24.78 8.805a1.073 1.073 0 0 1 1.624 -0.938l21.078 12.679a1.073 1.073 0 0 1 -0.017 1.848l-20.637 11.912a1.073 1.073 0 0 1 -1.608 -0.907Z" fill="currentColor" />
        </svg>
    </button>`;
export const nextArrow = `
    <button class="slider__arrow slider__next slick-next link" aria-label="Next slide">
       <svg class="icon icon--arrow arrow--right" xmlns="http://www.w3.org/2000/svg" viewBox="0 7.709 48 26.739" width="48" height="26.739">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4.288586106767925" d="M2.145 21.879h37.669" />
            <path d="M24.78 8.805a1.073 1.073 0 0 1 1.624 -0.938l21.078 12.679a1.073 1.073 0 0 1 -0.017 1.848l-20.637 11.912a1.073 1.073 0 0 1 -1.608 -0.907Z" fill="currentColor" />
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'cubic-bezier(.4,1.44,.71,1)',
    speed: 400,
    nextArrow: nextArrow,
    prevArrow: prevArrow
};

